import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { SandboxBanner } from "./components/layout/SandboxBanner";
import { RequireAuth } from "./components/RequireAuth";
import { Dashboard } from "./pages/Dashboard";
import { TeamsList } from "./pages/teams/TeamsList";
import { TeamDetail } from "./pages/teams/TeamDetail";
import { CompaniesList } from "./pages/companies/CompaniesList";
import { CompanyDetail } from "./pages/companies/CompanyDetail";
import { HealthDashboard } from "./pages/HealthDashboard";
import { ProcessesList } from "./pages/ProcessesList";
import { SubscriptionsList } from "./pages/SubscriptionsList";
import { LoginPage } from "./pages/Login";
import { AuthCallbackPage } from "./pages/AuthCallback";

export default function App() {
  return (
    <>
      <SandboxBanner />
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="teams" element={<TeamsList />} />
        <Route path="teams/:teamId" element={<TeamDetail />} />
        <Route path="companies" element={<CompaniesList />} />
        <Route path="companies/:companyId" element={<CompanyDetail />} />
        <Route path="health" element={<HealthDashboard />} />
        <Route path="dian-processes" element={<ProcessesList />} />
        <Route path="subscriptions" element={<SubscriptionsList />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </>
  );
}